module.exports = __webpack_public_path__ + "static/media/settings-grey.b2fda9eb.svg";